import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { Category, CategoryKey } from '@seatsio/seatsio-react';
import { FormattedMessage } from 'react-intl';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

import FilterItem from './FilterItem';

interface Props {
  subtitle: string | null;
  filteredCategories: Array<CategoryKey>;
  categories: Array<Category>;
  open: boolean;
  onFilterCategory: (category: CategoryKey) => void;
  onClose: () => void;
}

const CategoryFilterDialog = ({
  subtitle,
  filteredCategories,
  categories,
  onFilterCategory,
  open,
  onClose,
}: Props) => {
  return (
    <ResponsiveDrawerDialog isOpen={open} onClose={onClose}>
      <DialogTitle>
        <Stack>
          <Typography
            variant="h6"
            sx={{
              mb: '2px',
            }}
          >
            <FormattedMessage id="event.seating.ticket_types" />
          </Typography>
          <Typography
            variant="extraSmall"
            sx={{
              fontWeight: 800,
              color: 'global01.400',
            }}
          >
            {subtitle}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            gap: 1,
          }}
        >
          {categories.map((category) => (
            <FilterItem
              key={category.key}
              category={category}
              selected={filteredCategories.includes(category.key)}
              onClick={onFilterCategory}
            />
          ))}
        </Stack>
      </DialogContent>
    </ResponsiveDrawerDialog>
  );
};

export default CategoryFilterDialog;
